<template>
  <v-container v-if="loading" fill-height :pa-0="$vuetify.breakpoint.smAndDown">
    <v-layout align-center justify-center>
      <v-flex xs12>
        <loading/>
      </v-flex>
    </v-layout>
  </v-container>
  <v-container fluid :pa-0="$vuetify.breakpoint.smAndDown" v-else>
    <v-card>
      <v-card-title>
        <balance-document-toolbar
          :id="id"
          :name="name"
          :title="title"
          :created_on="document.created_on"
        />
      </v-card-title>
      <component
        v-if="document.records.length"
        :is="itemsDisplayComponent"
        :records="document.records"
        :summa="document.summa"
      />
      <empty-table
        v-else
        :emptyText="'Нет документов'"
      />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat color="orange" @click="$router.go(-1)">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import balanceDocument from '../mixins/balanceDocument'

export default {
  name: 'vozvratnaya-nakladnaya-zakaz',
  mixins: [
    balanceDocument
  ],
  data () {
    return {
      name: 'vozvratnayanakladnaya_zakaz',
      title: 'Отмена заказа (внешнего)'
    }
  }
}
</script>

<style>
</style>
